import { Modelo } from '@ext/index';
import * as Types from './Variaciones.types';
import moment, { Moment } from 'moment';
import { Atributo } from '@lib/MercadoLibre/Publicaciones/Publicacion.types';

export class IVariaciones extends Modelo
{

    public constructor ( Json: any = null )
    {
        super( Json );
        if ( Json )
            this.set();
    }

    public Publicacion: string = '';
    public Variacion: number = 0;
    public Atributos: Atributo[] = [];
    public Precio: number = 0;


    public getJson (): any
    {
        let json: any = {};

        json.publicacion = this.Publicacion;
        json.variacion = this.Variacion;
        json.precio = this.Precio;


        return json;
    }


    public set (): boolean
    {

        this.Publicacion = !this.Json.publicacion ? '' : this.Json.publicacion;
        this.Variacion = !this.Json.variacion ? 0 : this.Json.variacion;
        this.Precio = !this.Json.precio ? 0 : this.Json.precio;

        if ( Array.isArray( this.Json.atributos ) )
        {
            this.Atributos.push( ...this.Json.atributos.map( ( x: any ) => new Atributo( x ) ) );
        }

        this.Existe = true;
        return this.Existe;
    }

    public get Vista (): Vista
    {
        return new Vista( this );
    }
}

class Vista
{
    constructor ( Model: IVariaciones )
    {
        this.Model = Model;
    }

    public Model: IVariaciones;
}